<div class="row dashboard-panel" *ngIf="level != 'student' || hasStudentKpis">
  <div class="pillar-container col-md-3 col-sm-12 col-xs-12">
    <panel-header
      [title]="metadata.title"
      [description]="metadata.text"
      [tier]="tier"
      class="panel-header"
    ></panel-header>
  </div>
  <div class="tiles-container col-md-9 col-sm-12 col-xs-12">
    <div
      *ngFor="let tile of metadata.tiles; trackBy: trackByTileFn"
      [ngClass]="{ 'expand-tile': level == 'student' && tile.studentKPIs[0] }"
    >
      <div
        class="col-md-4 col-sm-12 col-xs-12 tile-container"
        *ngIf="level != 'student'"
      >
        <div class="thumbnail mosaic-tile">
          <tile
            [metadata]="tile"
            [level]="level"
            [entityId]="entityId"
            [studentFirstName]="studentFirstName"
            [role]="role"
            [hasAllSchools]="hasAllSchools"
            [filterCategory]="filterCategory"
            [filterValue]="filterValue"
            [useRealTimeSchoolProfileRequest]="useRealTimeSchoolProfileRequest"
            (clearFilterEvent)="clearFilterEvent.emit()"
            #Tile
          ></tile>
        </div>
      </div>
      <expand-tile
        [metadata]="tile"
        [studentFirstName]="studentFirstName"
        [entityId]="entityId"
        [custId]="custId"
        [schoolMinGradeLevel]="schoolMinGradeLevel"
        *ngIf="level == 'student' && tile.studentKPIs[0]"
      ></expand-tile>
    </div>
  </div>
</div>
